module.exports = __webpack_public_path__ + "img/nav_5.7d10c309.png";